// extracted by mini-css-extract-plugin
export default {"details":"styles_details__diDDE"};